
export const messages = {
    "home.title": "The best music is shared",
    "home.desc": "A web application for DJs to analyse music shared on social media. Sign up and get a never ending feed of inspiration for your DJ sets.",
    "home.line": "Audio Underground turns facebook posts into music playlists",

    "home.button.into": "Create your FREE account",

    "home.labelIcon": "Built for DJs & music professionals",
    "latest.noMoreTracks.labelIcon": "Built for DJs & music professionals",

    "home.features.slide1": "Search",
    "home.features.slide2": "Analyse",
    "home.features.slide3": "Trending",
    "home.features.slide4": "Discover",
    "home.features.slide5": "Create",

    "home.feature.marketing.strip.title": "A treasure chest of underground music",
    "home.feature.marketing.strip.desc": "An app for music discovery like no other!",

    "home.sign_up_block.title": "Discover Audio Underground for free",
    "home.sign_up_block.desc": "Our intuitive platform is built for DJs and music professionals to find the best music around, all in one place. Sign up now and begin your journey of music discovery. ",
    "home.sign_up_block.labelIcon": "Built for DJs & music professionals",
    "home.sign_up_block.button": "Start your free trial",

    "latest.placeholder.title": "Welcome to Audio Underground",
    "latest.placeholder.heading": "You don't have any subscriptions yet!",
    "latest.placeholder.text": "Search for your favourite artists, labels and DJs to discover what music they share across social media.",
    "latest.placeholder.text2": "New to Audio Underground?",
    "latest.placeholder.label": "Built for DJs & music professionals",

    "subscriptions.placeholder.title": "Welcome to Audio Underground",
    "subscriptions.placeholder.heading": "You don't have any subscriptions yet!",
    "subscriptions.placeholder.text": "Search for your favourite Artists, Record Labels, DJs and discover what music they share across social media. You can subscribe to your favoutite pages to get the latest music omn this page.",
    "subscriptions.placeholder.text2": "New to Audio Underground?",
    "subscriptions.placeholder.label": "Built for DJs & music professionals",

    "playlists.placeholder.title": "Welcome to Audio Underground",
    "playlists.placeholder.heading": "You don't have any playlists yet!",
    "playlists.placeholder.text": "Search for your favourite Artists, Record Labels, DJs and discover what music they share across social media. You can subscribe to your favoutite pages to get the latest music omn this page.",
    "playlists.placeholder.text2": "New to Audio Underground?",
    "playlists.placeholder.label": "Built for DJs & music professionals",

    "onboarding.latest.title": "Welcome to Audio Underground",
    "onboarding.latest.brief": "Audio Underground catalogues the music shared on facebook pages and keeps you up to date with the most liked music. You can filter tracks by the time it's been shared and the popularity.",

    "onboarding.search.title": "Search",
    "onboarding.search.brief": "Our powerful search allows you to discover the best Underground music shared by anyone in the music business, whether it be a DJ, producer, artist, nightclub or facebook group. ",

    "onboarding.collections.title": "Collections",
    "onboarding.collections.brief": "Once you have searched for your favourite artist, DJ or producer you can see what music they share and filter by most liked, commented or currently trending.",

    "onboarding.connections.title": "Connections",
    "onboarding.connections.brief": "Start your journey through music by seeing who your favourite artists perosnally connect with.",

    "onboarding.subscribe.title": "Subscribe",
    "onboarding.subscribe.brief": "Subscribe to your favourite pages and keep right up to date with what's being shared on your homepage.",

    "onboarding.discover.title": "Short of inspiration?",
    "onboarding.discover.brief": "Use our Discover tool to check out our favoutite pages who share top quality music.",

    "onboarding.create.title": "Build your catalogue",
    "onboarding.create.brief": "Save your favourite tracks and build inspiration playlists for your sets. You can re-order your tracks by dragging them around.",

    "latest.noMoreTracks.title": "End of tracklist",
    "latest.noMoreTracks.desc": "No more tracks have been posted in this time period. Try changing your time period in the top right dropdown or subscribing to more pages.",
    "latest.noMoreTracks.tagline": "Need sone inspiration?",


    "techno.heading": "Techno",
    "techno.desc": "Need sone inspiration?",

    "house.heading": "House",
    "house.desc": "Need sone inspiration?",

    "electronica.heading": "Electronica",
    "electronica.desc": "Need sone inspiration?"

};

//import { FormattedMessage } from 'react-intl';
//<FormattedMessage id='home.title' />



// WEBPACK FOOTER //
// ./src/locale/en/messages.js